import * as React from "react";
import { SnackbarProps } from "@mui/joy";

type AlertMessage = {
  title: string;
  message: string;
  color: SnackbarProps["color"];
};
export const useAlert = () => {
  const [openAlert, setOpenAlert] = React.useState<boolean>(false);
  const [alertMessage, setAlertMessage] = React.useState<AlertMessage>({
    title: "",
    message: "",
    color: "neutral",
  });

  const handleOpenAlert = () => setOpenAlert(true);
  const handleCloseAlert = (
    event?: React.SyntheticEvent | Event | null,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenAlert(false);
  };

  return {
    openAlert,
    handleOpenAlert,
    handleCloseAlert,
    alertMessage,
    setAlertMessage,
  };
};
